import { Navigate, RouteObject } from "react-router";

import { AdminRouteGuard } from "@components/RouteGuards/AdminRouteGuard";

import { routes } from "@pages/routes";

import { ApplicationsPage } from "./Applications.page";
import { OrganizationsPage } from "./Organizations.page";

export const administrationRoutes: RouteObject[] = [
  {
    index: true,
    Component: () => (
      <AdminRouteGuard>
        <Navigate to={routes.portal.administration.applications.$path()} replace />
      </AdminRouteGuard>
    ),
  },
  {
    path: "applications",
    handle: { fullBleed: true },
    Component: () => (
      <AdminRouteGuard>
        <ApplicationsPage />
      </AdminRouteGuard>
    ),
  },
  {
    path: "organizations",
    handle: { fullBleed: true },
    Component: () => (
      <AdminRouteGuard>
        <OrganizationsPage />
      </AdminRouteGuard>
    ),
  },
];